/* eslint-disable no-unused-vars */
import {
  BaSeActionItem,
  BaSeContainer,
  BaSeDataTable,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { useModule } from '../../../../hooks/module/module';
import { ItemResultEntrevista } from '../../pages/candidates/candidates-styled';
import { useMenu } from '../../pages/candidates/hook/useMenu';
import { EmailDate } from '../data-table/email-date';
import { InterviewResult } from '../data-table/interview-result';
import { InterviewStatus } from '../data-table/interview-status';
import { PersonalData } from '../data-table/personal-data';

function VisualizarhistoricoEntrevista({ idCandidate, closeModal, emitEvent }) {
  const { getMenuItems, formatDate } = useMenu();

  const { loading, buscarListaDeEntrevistas } = useInterviewController();

  const [interviews, setInterviews] = React.useState([]);

  const { moduleSelected } = useModule();

  const fetchData = React.useCallback(() => {
    buscarListaDeEntrevistas(moduleSelected?.id, idCandidate)
      .then((response) => {
        setInterviews(response);
      })
      .catch(() => setInterviews([]));
  }, [buscarListaDeEntrevistas, idCandidate, moduleSelected]);

  const configTable = [
    {
      accessorKey: 'candidate.name',
      header: 'Dados pessoais',
      mapper: ({ values }) => <PersonalData props={values} />,
    },
    {
      accessorKey: 'city.uf.initials',
      header: 'UF',
      mapper: ({ values }) => {
        return (
          <BaSeSmall1
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            {values.city.uf.initials}
          </BaSeSmall1>
        );
      },
    },
    {
      accessorKey: 'city.name',
      header: 'Cidade',
      mapper: ({ values }) => (
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {values.city.name}
        </BaSeSmall1>
      ),
    },
    {
      id: 'sendingRegistrationEmail',
      header: 'E-mail de inscrição',
      mapper: ({ values }) => <EmailDate props={values} />,
    },
    {
      accessorKey: 'statusCompletingInterview',
      header: 'Status da entrevista',
      mapper: ({ values }) => <InterviewStatus props={values} />,
    },
    {
      accessorKey: 'statusInterview',
      header: 'Resultado da entrevista',
      mapper: ({ values }) => (
        <ItemResultEntrevista>
          <InterviewResult props={values} />
          <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            {values.processingDate
              ? ` Processado: ${formatDate(new Date(values.processingDate))}`
              : ''}
          </BaSeSmall1>
        </ItemResultEntrevista>
      ),
    },
    {
      header: 'Opções',
      mapper: ({ values, reloadData }) => (
        <BaSeActionItem
          position="top-right"
          minWidth="270px"
          closeOnAction={false}
          color={BaSeTheme.colors.institucionais.azulSebrae10}
          items={getMenuItems(values, reloadData, 2, closeModal, emitEvent)}
        />
      ),
    },
  ];

  return (
    <BaSeContainer withAutoScroll>
      <BaSeDataTable
        config={configTable}
        fetchData={fetchData}
        loading={loading}
        width="99%"
        shadow="0"
        backgroundColor={BaSeTheme.colors.defaultColors.white}
        filterAreaBackgroundColor={BaSeTheme.colors.defaultColors.white}
        initialPageSize={10}
        textFilterWidth={345}
        items={interviews}
        title={`Histórico: ${interviews[0]?.candidate.name}`}
        configActionItemsProps={{ icon: 'ellipsis-v' }}
      />
    </BaSeContainer>
  );
}

export default VisualizarhistoricoEntrevista;
